import {
  Box,
  Button,
  ButtonBase,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContainerGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  minHeight: '720px',
  height: '100vh',
  justifyContent: 'center',
  background: theme.palette.primary.main,
}));

export const LogoGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const LogoImg = styled(Box)(({ theme }) => ({
  zIndex: 5,
  img: {
    [theme.breakpoints.down('lg')]: {
      width: 400,
    },
    [theme.breakpoints.up('lg')]: {
      width: 547,
    },
  },
}));

export const LoginGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.common.white,
  borderTopLeftRadius: '30px',
  borderBottomLeftRadius: '30px',
}));

export const InputBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const InputTitle = styled(Typography)(() => ({
  fontSize: '37px',
  marginBottom: '140px',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: '40px',
  [theme.breakpoints.down('md')]: {
    width: '280px',
  },
  [theme.breakpoints.up('md')]: {
    width: '320px',
  },
  [theme.breakpoints.up('xl')]: {
    width: '500px',
  },
  '& .MuiInputBase-input': {
    fontSize: '18px',
  },
  '& .MuiInputBase-root.MuiInput-root:before': {
    borderBottom: '1px solid #D7D8DB99',
  },
  '& .MuiInputBase-root.MuiInput-root:after': {
    borderBottom: '1px solid #D7D8DB99',
  },
  '& .MuiInputBase-root.MuiInput-root.Mui-error:before': {
    borderBottom: '1px solid #d32f2f',
  },
  '& .MuiInputBase-root.MuiInput-root.Mui-error:after': {
    borderBottom: '1px solid #d32f2f',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:before': {
    borderBottom: '1px solid #D7D8DB99',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:after': {
    borderBottom: '1px solid #D7D8DB99',
  },
  'input:-webkit-autofill': {
    WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.common.white} inset`,
    paddingLeft: '10px',
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  margin: '40px 0',
  paddingTop: '10px',
  borderRadius: '16px',
  backgroundColor: theme.palette.secondary.main,
  fontWeight: '700',
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    filter: 'brightness(85%)',
  },
  [theme.breakpoints.down('md')]: {
    width: '280px',
  },
  [theme.breakpoints.up('md')]: {
    width: '320px',
  },
  [theme.breakpoints.up('xl')]: {
    width: '500px',
  },
}));

export const StyledButtonBase = styled(ButtonBase)(() => ({
  textDecoration: 'underline',
  fontSize: '18px',
  '&:hover': {
    fontWeight: '600',
  },
}));
